<template>
  <div>
    <h1>I am a back door</h1>
    <DeleteEnityWdiget :entityName="'legal-person'" />
    <DeleteEnityWdiget :entityName="'natural-person'" />
    <DeleteEnityWdiget :entityName="'sp-person'" />
    <DeleteEnityWdiget :entityName="'asset'" />
  </div>
</template>

<script>
import DeleteEnityWdiget from "../widgets/DeleteEnityWdiget.vue";
export default {
  name: "BackDoor",
  components: {
    DeleteEnityWdiget
  },
  data() {
    return {
      isDone: false,
      itn: null,
      rrc: null
    };
  },
  mounted() {
    console.warn("You cannot access it!");
    this.$router.push("/");
  }
};
</script>
<style>
.config {
  margin: 20px;
}
</style>

